import React from "react";
// import CommunityNavigationStore, {
//   CommunityView,
// } from "../../navigation/communityNavigationStore";
import EventButton, {
  EventButtonVariant,
} from "../../shared/components/EventButton";

export const SendSetupsConfirmationContent: React.FC<{
  onSendNow: () => void;
}> = ({ onSendNow }) => (
  <div className="rounded-2xl p-8 max-w-md mx-auto">
    <h2 className="text-white text-3xl font-nostalgic text-center mb-12 leading-tight">
      Are you sure you want to send out setups? This can only be done once.
    </h2>

    <div className="space-y-4">
      <EventButton
        onClick={onSendNow}
        variant={EventButtonVariant.GRADIENT}
        className="w-full text-lg py-4"
        icon="❤️‍🔥"
      >
        Yes, send now
      </EventButton>
      {/* 
        <EventButton
          onClick={onSchedule}
          variant={EventButtonVariant.TRANSPARENT}
          className="w-full text-lg py-4"
          icon="⏱"
        >
          Schedule for later
        </EventButton> */}
    </div>
  </div>
);

export const RegenerateSetupsConfirmationContent: React.FC<{
  onRegenerate: () => void;
}> = ({ onRegenerate }) => (
  <div className="rounded-2xl p-8 max-w-md mx-auto">
    <h2 className="text-white text-3xl font-nostalgic text-center mb-6 leading-tight">
      Are you sure you want to
      <br />
      regenerate your setups?
    </h2>
    <p className="text-white/60 text-center mb-10 text-base">
      This will not change all of your setups but may shift them slightly.
      Manual setups will not change.
    </p>
    <EventButton
      onClick={onRegenerate}
      variant={EventButtonVariant.GRADIENT}
      className="w-full text-lg py-4"
      icon="🔄"
    >
      Yes, regenerate setups
    </EventButton>
  </div>
);

const SetupsPopUp = SendSetupsConfirmationContent;

export default SetupsPopUp;
